import {takeEvery, put, select} from 'redux-saga/effects';
import {DATASET_METADATA} from '.';
import {runJob} from './job';

function* updateStats(res) {
  const datasetId = yield select(state => state.dataset.data?.id);
  if (datasetId) {
    yield put(
      runJob({
        datasetId,
        type: 'ANALYZE_WIP',
      })
    );
  }
}

export function* watchDatasetMetadata() {
  yield takeEvery(`${DATASET_METADATA}/update/fulfilled`, updateStats);
  yield takeEvery(`${DATASET_METADATA}/delete/fulfilled`, updateStats);
}
